var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "loading" }, [
    _c(
      "div",
      { staticClass: "text text-xs-center" },
      [
        _c("v-progress-circular", {
          staticClass: "mx-auto",
          attrs: { size: 70, color: "white", indeterminate: "" },
        }),
        _vm._v(" "),
        _c("div", { staticClass: "headline mt-3" }, [_vm._v("Loading...")]),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }